import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

// Define the context value type
type HotkeyBlockContextType = {
  isHotkeyBlocked: boolean
  blockHotkeys: () => void
  unblockHotkeys: () => void
}

// Create the context with a default value of `undefined`
const HotkeyBlockContext = createContext<HotkeyBlockContextType | undefined>(undefined)

// Provider Component
export const HotkeyBlockProvider = ({ children }: { children: ReactNode }) => {
  const [isHotkeyBlocked, setIsHotkeyBlocked] = useState(false)

  const blockHotkeys = useCallback(() => {
    setIsHotkeyBlocked(true)
  }, [])

  const unblockHotkeys = useCallback(() => {
    setIsHotkeyBlocked(false)
  }, [])

  return (
    <HotkeyBlockContext.Provider value={{ isHotkeyBlocked, blockHotkeys, unblockHotkeys }}>
      {children}
    </HotkeyBlockContext.Provider>
  )
}

// Custom hook
export const useHotkeyBlock = (): HotkeyBlockContextType => {
  const context = useContext(HotkeyBlockContext)
  if (!context) {
    throw new Error('useHotkeyBlock must be used within a HotkeyBlockProvider')
  }
  return context
}
